import axiosInstance from "../../axios";
import { GET_RISK_SCENARIOS_REQUEST } from "../types/riskScenariosTypes";
import {
  requestFailed,
  requestStarted,
  requestSucceeded,
} from "./feedbackActionCreators";
import { claimOrgScopedRequest } from "./orgScopedRequest";

export const getRiskScenariosRequest = (risk_scenarios) => {
  return {
    type: GET_RISK_SCENARIOS_REQUEST,
    payload: risk_scenarios,
  };
};

export const fetchRiskScenarios = (orgaId) => {
  return async (dispatch) => {
    const isCurrent = claimOrgScopedRequest("risk_scenarios");
    dispatch(requestStarted("risk_scenarios"));
    // The outgoing org goes before the request leaves, so a failure cannot leave
    // its scenarios on screen under the org you just opened.
    dispatch(getRiskScenariosRequest([]));

    try {
      const res = await axiosInstance.get(`/survey/risk_scenarios/${orgaId}`);
      if (!isCurrent()) {
        // Superseded, but the loading counter it took on the way in still has
        // to be given back: feedbackReducer counts starts against successes and
        // the global overlay sits on the total. Returning without this leaks a
        // count the page can never get back, and it hangs until a reload.
        dispatch(requestSucceeded());
        return;
      }
      const data = res.data;
      dispatch(getRiskScenariosRequest(data?.risk_scenarios));
      dispatch(requestSucceeded());
    } catch (error) {
      if (!isCurrent()) {
        // Superseded, but the loading counter it took on the way in still has
        // to be given back: feedbackReducer counts starts against successes and
        // the global overlay sits on the total. Returning without this leaks a
        // count the page can never get back, and it hangs until a reload.
        dispatch(requestSucceeded());
        return;
      }
      dispatch(requestFailed(error?.response?.data));
    }
  };
};
